import store from '@/store'

/**
 * Display error message for failed request
 * @param {Object} options Handler options
 * @param {Object} options.error Request error response
 * @param {string} [options.fallback] Fallback message
 */
export default function ({ error, fallback } = {}) {
  let text

  // Try to get message from error response
  if (error && error.response && error.response.data && error.response.data.detail) {
    text = error.response.data.detail
  // Use the error object message
  } else if (error && error.hasOwnProperty('message') && error.message) {
    text = error.message
  // Use fallback if error message is missing
  } else if (fallback) {
    text = fallback
  // Fallback for fallback
  } else {
    text = 'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut'
  }

  store.commit('notifications/add', { text, type: 'error' })
}
